import axios from "axios";
import Links from "../constants/Links";


const Support = {
  /**
   * 
   * @param {object} data 
   * @returns {Promise<object>}
   */
  create: async (data) => {
    return axios.post(Links.support.create, data)
  }, 

  /**
   * 
   * @param {string} supportId
   * @param {object} data
   * @returns {Promise<object>}
   */
  update: async (supportId, data) => {
    return axios.put(Links.support.update + '/' + supportId, data)
  },
  
   /**
   * 
   * @param {string} supportId
   * @returns {Promise<object>}
   */
  get: async (supportId) => {
    return axios.get(Links.support.get + supportId)
  },

  /**
   * 
   * @param {string} supportId 
   * @returns {Promise<object>}
   */
  delete: async (supportId) => {
    return axios.delete(Links.support.delete + '/' + supportId)
  }, 

  /**
   * 
   * @returns {Promise<Array>}
   */
  all: async () => {
    return axios.get(Links.support.all); 
  },

  /**
   * Bootstrap an authenticated student support session. Authentication is
   * supplied by the global axios interceptor; this request intentionally has
   * no body and never contains the portal's server-side session key.
   *
   * @returns {Promise<{apiKey: string}>}
   */
  bootstrapWidget: async () => {
    const response = await axios.post(Links.support.widgetBootstrap);
    const data = response.data || {};

    if (!data.apiKey) {
      throw new Error("Invalid support widget bootstrap response");
    }

    return {
      apiKey: data.apiKey,
    };
  }
}; 


export default Support;
